import { UPDATE_DEFAULT_MANAGE_COLUMN_NAME, WATCHLIST } from "../actionTypes";
const initialState = {
    objscripsAdditionalInfo: {},
    watchlists: [],
    activeWatchList: {},
    openWatchlists: [],
    selectedWatchlist: [],
    sectorWiseHeatMapData: [],
    heatMapData: [],
    globalWatchlists: [],
    columnDef: [],
    isGuestLoading: true,
    watchlistInfo: [],
    isWatchlistPresent: false,
    isLoadingUpdateWatchlist: false,
    globalColumnProfiles: [],
    userColumnProfiles: [],
    isColumnPresent: false,
    columnViewType: '',
    isPiviotPresent: false,
    dashboardWatchlists: {},
    arrSelecedScripForDelete: [],
    arrScripsAdditionalInfo: [],
    strFocusedCards: null,
    //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
    tenantColumnProfiles: [],
    objViewWiseColumnProfiles: {},
    objColumnUpdatedDetails: {},
    //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - End

    //Ameersha N -12-12-2023 - BREEZE - BT-95888 -Create Watchlist -Start
    isHoldingsWatchlistUpdated: false,
    //Ameersha N -12-12-2023 - BREEZE - BT-95888 -Create Watchlist -End
    objWatchlistScripIndexes: {}, // Azeem K -05-07-2024 : Watchlist Optimization
    selectedHeatmapTile: [],
    popoverOpen: false,
    defaultManageColumnName: '',
};

const watchListReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case WATCHLIST.UPDATE_COLUMNS_UPTO_DATE: {
            return {
                ...state,
                objColumnUpdatedDetails: actions?.payload
            };
        }
        case 'WAT_SCRIP_ADD_INFO': {
            return {
                ...state,
                objscripsAdditionalInfo: actions?.payload
            };
        }
        //Ameersha N -12-12-2023 - BREEZE - BT-95888 -Create Watchlist -Start
        case WATCHLIST?.UPDATE_HOLDINGS_WATCHLIST: {
            return {
                ...state,
                isHoldingsWatchlistUpdated: actions?.payload
            };
        }
        //Ameersha N -12-12-2023 - BREEZE - BT-95888 -Create Watchlist -End
        //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
        case WATCHLIST?.UPDATE_VIEW_WISE_COLUMN_PROFILES: {
            return {
                ...state,
                objViewWiseColumnProfiles: actions?.payload
            };
        }
        //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - End

        // Deepti b. BT-107398 [18/11/2024]: selected heatmap tile data
        case WATCHLIST?.UPDATE_SELECTED_HEATMAP_TILE_WATCHLIST: {
            return {
                ...state,
                selectedHeatmapTile: actions.payload
            };
        }

        //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
        case WATCHLIST?.UPDATE_TENANT_COLUMN_PROFILES: {
            return {
                ...state,
                tenantColumnProfiles: actions?.payload
            };
        }
        //Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - End
        case WATCHLIST?.UPDATE_IS_PIVIOT_PRESENT: {
            return {
                ...state,
                isPiviotPresent: actions?.payload
            };
        }

        case WATCHLIST?.UPDATE_STR_VIEW_TYPE: {
            return {
                ...state,
                columnViewType: actions?.payload
            };
        }

        case WATCHLIST?.UPDATE_IS_COLUMN_PRESENT: {
            return {
                ...state,
                isColumnPresent: actions?.payload
            };
        }

        case WATCHLIST?.UPDATE_GLOBAL_COLUMN_PROFILES: {
            return {
                ...state,
                globalColumnProfiles: actions?.payload
            };
        }
        case WATCHLIST?.UPDATE_USER_COLUMN_PROFILES: {
            return {
                ...state,
                userColumnProfiles: actions?.payload
            };
        }

        case WATCHLIST.UPDATE_WATCHLIST_LOADING: {
            return {
                ...state,
                isLoadingUpdateWatchlist: actions.payload
            };
        }
        case WATCHLIST.UPDATE_WATCHLIST_IS_PRESENT: {
            return {
                ...state,
                isWatchlistPresent: actions.payload
            };
        }

        case WATCHLIST.UPDATE_WATCHLISTS: {
            return {
                ...state,
                watchlists: actions.payload
            };
        }
        case WATCHLIST.UPDATE_WATCHLISTS_INFO: {
            return {
                ...state,
                watchlistInfo: actions.payload
            };
        }
        case WATCHLIST.UPDATE_ACTIVE_WATCHLIST: {
            return {
                ...state,
                activeWatchList: actions.payload
            };
        }
        case WATCHLIST.UPDATE_SELECTED_WATCHLIST: {
            return {
                ...state,
                selectedWatchlist: actions.payload
            };
        }
        case WATCHLIST.UPDATE_OPEN_WATCHLIST: {
            return {
                ...state,
                openWatchlists: actions.payload
            };
        }
        case "TOUCHLINE": {
            return state;
        }
        case WATCHLIST.UPDATE_GLOBAL_WATCHLIST: {
            return {
                ...state,
                globalWatchlists: actions.payload
            };
        }

        case WATCHLIST.GET_COLUMNDEF_SUCCESS: {
            return {
                ...state,
                columnDef: actions.payload
            };
        }

        case WATCHLIST.GET_COLUMNDEF_FAILURE: {
            return {
                ...state,
                columnDef: actions.payload
            };
        }
        case WATCHLIST.UPDATE_GUEST_IS_LOADING: {
            return {
                ...state,
                isGuestLoading: actions.payload
            };
        }
        case WATCHLIST.UPDATE_DASHBOARD_WATCHLIST: {
            return {
                ...state,
                dashboardWatchlists: actions.payload
            };
        }
        case WATCHLIST.SELECT_SCRIP_FOR_DELETE: {
            return {
                ...state,
                arrSelecedScripForDelete: actions.payload
            };
        }
        case WATCHLIST.GET_SCRIPS_ADDITIONAL_INFO_SUCCESS: {
            return {
                ...state,
                arrScripsAdditionalInfo: actions.payload
            };
        }
        case WATCHLIST.GET_SCRIPS_ADDITIONAL_INFO_FAILURE: {
            return {
                ...state,
                arrScripsAdditionalInfo: actions.payload
            };
        }
        case WATCHLIST.GET_FOCUS_CARD: {
            return {
                ...state,
                strFocusedCards: actions.payload
            };
        }
        // Azeem K -05-07-2024 : Watchlist Optimization --Start
        case WATCHLIST.WATCHLIST_SCRIP_INDEXES: {
            return {
                ...state,
                objWatchlistScripIndexes: actions.payload
            };
        }
        // Azeem K -05-07-2024 : Watchlist Optimization --End
        case WATCHLIST.IS_POPOVER_OPEN: {
            return {
                ...state,
                popoverOpen: actions.payload
            };
        }
        case UPDATE_DEFAULT_MANAGE_COLUMN_NAME: {
            return {
                ...state,
                defaultManageColumnName: actions.payload
            };
        }
        default:
            return state;
    }

};

export default watchListReducer;




